import { useFormState } from 'react-use-form-state';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from '@apollo/react-hooks';

import { CREATE_CUSTOMER } from './queries';

const _v = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  password: 'password',
  confirmPassword: 'confirmPassword',
  phone: 'phone',
  dateOfBirth: 'dateOfBirth',
  gender: 'gender',
};

const messageOpts = {
  new: 'new',
  dup: 'dup',
};

const useCreateCustomer = ({ setModalState } = {}) => {
  const [formState, form] = useFormState({});
  const { addToast } = useToasts();

  const [runMutation, { loading }] = useMutation(CREATE_CUSTOMER, {
    onCompleted: () => {
      setModalState({
        isOpen: true,
        showMessage: messageOpts.new,
      });
      formState.reset();
    },
    onError: (err) => {
      console.log(err);
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((e) => {
          if (e.message.includes('.customers index: email_1 dup key:')) {
            setModalState({
              isOpen: true,
              showMessage: messageOpts.dup,
            });
          } else {
            addToast(e.message, {
              appearance: 'error',
              autoDismiss: true,
            });
          }
        });
      } else {
        addToast('Something unexpected happened', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // TODO: validation
    // if (formState.values[_v.password] !== formState.values[_v.confirmPassword]) {
    //   addToast('Passwords do not match', {
    //     appearance: 'error',
    //     autoDismiss: true,
    //     autoDismissTimeout: 10000,
    //   });
    //   formState.setFieldError(_v.confirmPassword, 'Passwords do not match');
    //   return;
    // }

    const data = {
      firstName: formState.values[_v.firstName],
      lastName: formState.values[_v.lastName],
      email: formState.values[_v.email],
      // password: formState.values[_v.password],
      phone: formState.values[_v.phone],
      dateOfBirth: formState.values[_v.dateOfBirth],
      gender: formState.values[_v.gender],
    };

    runMutation({ variables: { data } });
  };

  return {
    _v,
    form,
    formState,
    handleSubmit,
    loading,
    messageOpts,
  };
};

export default useCreateCustomer;
